export interface MimeTypeConfig {
	mime: string;
	extensions: string[];
}

export type MimeTypeKey = "DOC" | "DOCX" | "GIF" | "JPG" | "MP4" | "MOV" | "PDF" | "PNG" | "TIFF";

export const MimeTypes: Record<MimeTypeKey, MimeTypeConfig> = {
	DOC: { mime: "application/msword", extensions: ["doc"] },
	DOCX: { mime: "application/vnd.openxmlformats-officedocument.wordprocessingml.document", extensions: ["docx"] },
	GIF: { mime: "image/gif", extensions: ["gif"] },
	JPG: { mime: "image/jpeg", extensions: ["jpg", "jpeg"] },
	PDF: { mime: "application/pdf", extensions: ["pdf"] },
	MP4: { mime: "video/mp4", extensions: ["mp4"] },
	PNG: { mime: "image/png", extensions: ["png"] },
	TIFF: { mime: "image/tiff", extensions: ["tif", "tiff"] },
	MOV: { mime: "video/quicktime", extensions: ["mov"] },
};

export function getMimes(keys: MimeTypeKey[]): string[] {
	return keys.map((key) => MimeTypes[key].mime);
}

export function getMimeFileTypes(keys: MimeTypeKey[]): string {
	return keys.flatMap((key) => MimeTypes[key].extensions).join(", ");
}
